module.exports = __webpack_public_path__ + "img/google-brands.7abf326d.svg";